import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

export const heroData = {
  title: "Hello, I am",
  name: 'Chetan !',
  subtitle: 'Engineer, Programmer & a reader,Can converse in C++, Javascript, TypeScript, English, Hindi.',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'A keen, creative, and analytical app and web development leader, with 3 years experience leading innovative projects that drive growth for technology brands.',
  paragraphTwo: 'I have specialized in mobile/web app development and optimization for the past 3 years. I am currently working at Beehively.Inc where I develop powerful and modern frontend architecture involving React, Redux, and ES6 and secure graphQl resolvers and write database queries using modern databases like Prisma.',
  paragraphThree: 'I also participate in competitive programming contests on platforms like hackerhank/codechef.',
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: "If you'd like to know more about me, grab a coffee or talk to me about your causes you are passionate about, I'd love to hear from you.",
  btn: '',
  email: 'prem.premsharma77@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/chetan_prem',
    },
    {
      id: nanoid(),
      name: 'code',
      url: 'https://www.hackerrank.com/Chetan_verma77',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/chetan-verma-17a37b180',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Chetan77verma',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
